import React from 'react'
import { useTranslation } from 'react-i18next'
import { TitleController } from '@pandiafi/design-system'
import {
  ResidentAppBackLink,
  ResidentAppCard,
  ResidentAppView,
} from '@pandiafi/components'

import { BulletinViewDataLoader } from './BulletinViewDataLoader'
import { ErrorHandler } from './BulletinViewErrorHandler'

import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'
import { Bulletin } from 'components/Bulletin/Bulletin'

export const BulletinView: React.FC = () => {
  const { t } = useTranslation(['common', 'titles', 'documents'])
  const { bulletinBoardPath } = useContractPaths()

  return (
    <TitleController title={t('titles:bulletin')}>
      <ResidentAppView
        title={t('common:views.bulletin')}
        backLink={
          <ResidentAppBackLink href={bulletinBoardPath}>
            {t('common:views.bulletinBoard')}
          </ResidentAppBackLink>
        }
      >
        <ResidentAppCard>
          <ErrorHandler>
            <BulletinViewDataLoader>
              {({ bulletin, onLanguageChange }) => (
                <Bulletin
                  bulletin={bulletin}
                  onLanguageChange={onLanguageChange}
                />
              )}
            </BulletinViewDataLoader>
          </ErrorHandler>
        </ResidentAppCard>
      </ResidentAppView>
    </TitleController>
  )
}
